module.exports = __webpack_public_path__ + "static/media/analitics1.28586b92.png";